import publikasiPengaduan from "../../../assets/img/publikasi-pengaduan/publikasi-pengaduan.png";
function HeaderPublikasiPengaduan() {

    return (
        <>
            <div className="publikasi-pengaduan">
                <div className="card-hero">
                    <div className="text">
                        <div className="row-title">
                            <h4>Kebijakan dan Publikasi Penanganan Pengaduan</h4>
                            <p>
                                Sebagai bentuk komitmen terhadap perlindungan konsumen, Danai.id menerapkan Kebijakan
                                Penanganan Pengaduan sesuai POJK Nomor 2 Tahun 2023 tentang Perlindungan Konsumen dan
                                Masyarakat di Sektor Jasa Keuangan.
                                <br/><br/>
                                Informasi mengenai prosedur, kanal pengaduan, serta publikasi penanganan pengaduan dapat
                                diakses melalui halaman ini.
                            </p>
                        </div>
                    </div>
                    <div className="image">
                        <img src={publikasiPengaduan} alt="publikasi-pengaduan"/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HeaderPublikasiPengaduan;